export const LgBpmnModdlePackages = {
	lowgile: {
		name: 'Lowgile BPMN extensions',
		uri: 'http://lowgile.com/bpmn',
		prefix: 'lowgile',
		types: [
			{
				name: 'UserTaskAssignment',
				superClass: ['Element'],
				properties: [
					{ name: 'variableName', isAttr: true, type: 'String' },
					{ name: 'expression', isAttr: true, type: 'String' },
				],
			},
			{
				name: 'UserTaskOutputHandler',
				superClass: ['Element'],
				properties: [
					{ name: 'outputName', isAttr: true, type: 'String' },
					{ name: 'code', isAttr: true, type: 'String' },
				],
			},
		],
	},
}

export const LgBpmnModdleExtensions = {
	lowgile: {
		...LgBpmnModdlePackages.lowgile,
		types: [
			...LgBpmnModdlePackages.lowgile.types,
			{
				name: 'lgUserTask',
				isAbstract: true,
				extends: ['bpmn:UserTask'],
				properties: [
					{ name: 'screenRef', isAttr: true, type: 'String' },
					{ name: 'priority', isAttr: true, type: 'Integer' },
					{ name: 'isPreferred', isAttr: true, type: 'Boolean' },
					{ name: 'isAutoAssign', isAttr: true, type: 'Boolean' },
					{
						name: 'assignments',
						isAttr: false,
						type: 'UserTaskAssignment',
						isMany: true,
					},
					{
						name: 'outputHandlers',
						isAttr: false,
						type: 'UserTaskOutputHandler',
						isMany: true,
					},
					{ name: 'onArrivalCode', isAttr: true, type: 'String' },
					{ name: 'canCancelProcessCode', isAttr: true, type: 'String' },
				],
			},
			{
				name: 'lgLane',
				isAbstract: true,
				extends: ['bpmn:Lane'],
				properties: [
					{ name: 'assigneeExpression', isAttr: true, type: 'String' },
					// { name: 'assigneeType', isAttr: true, type: 'String' },
				],
			},
			{
				name: 'lgFlowSequence',
				isAbstract: true,
				extends: ['bpmn:SequenceFlow'],
				properties: [{ name: 'onTakeCode', isAttr: true, type: 'String' }],
			},
			{
				name: 'lgSignal',
				isAbstract: true,
				extends: ['bpmn:Signal'],
				properties: [
					{ name: 'broadcastOutsideProcess', isAttr: true, type: 'Boolean' },
				],
			},
			{
				name: 'lgMessage',
				isAbstract: true,
				extends: ['bpmn:Message'],
				properties: [
					{ name: 'tsType', isAttr: true, type: 'String' },
					{ name: 'broadcastOutsideProcess', isAttr: true, type: 'Boolean' },
				],
			},
			{
				name: 'lgMessageEventDefinition',
				isAbstract: true,
				extends: ['bpmn:MessageEventDefinition'],
				properties: [
					{ name: 'messageDataProducer', isAttr: true, type: 'String' },
					{ name: 'messageDataHandler', isAttr: true, type: 'String' },
				],
			},
		],
	},
}
